













import { Component } from '@niknevis/vue-modules'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Vue from 'vue'
import { ModelSync } from 'vue-property-decorator'

@Component({
  components: {
    BaseInput
  }
})
export default class ShebaInput extends Vue {
  @ModelSync('value', 'input') valueSync: string

  get __value() {
    const shebaRegex = /^IR\d{0,24}/
    if (shebaRegex.test(this.valueSync)) {
      return this.valueSync.slice(2)
    }
    return parseInt(this.valueSync, 10) || null
  }

  set __value(v) {
    if (v) {
      this.valueSync = 'IR' + v.toString().replace(/-/g, '')
    } else {
      this.valueSync = null
    }
  }

  get __attrs() {
    return Object.fromEntries(
      Object.entries(this.$attrs).filter(([key]) => key !== 'value')
    )
  }

  get __listeners() {
    return Object.fromEntries(
      Object.entries(this.$listeners).filter(([key]) => key !== 'input')
    )
  }
}
